<div class="modal fade show" id="addTagModal" tabindex="-1" style="display: block;" aria-modal="true" role="dialog">
    <!-- Modal dialog with max-width constraint -->
    <div class="modal-dialog">
        <!-- Modal content -->
        <div class="modal-content">
            <!-- Modal header -->
            <div class="modal-header pb-0 border-0 justify-content-end">
                <!-- Close button -->
                <div class="btn btn-sm btn-icon btn-active-color-primary" (click)="closeModal()">
                    <i class="ki-outline ki-cross fs-1"></i>
                </div>
            </div>

            <!-- Modal body -->
            <div class="modal-body scroll-y mx-5 mx-xl-18 pt-0 pb-15">
                <!-- Heading -->
                <div class="text-center mb-13">
                    <h1 class="mb-3">{{ 'CAMPAIGN.ADD_TAG' | translate }}</h1>
                    <div class="text-muted fw-semibold fs-5">
                        {{ 'CAMPAIGN.SELECT_TAGS' | translate }}
                    </div>
                </div>

                <!-- Tags List -->
                <div class="mb-15">
                    <!-- List with scrolling and full-width items -->
                    <div class="mh-375px scroll-y me-n7 pe-7">
                        <div *ngFor="let tag of availableTags" class="d-flex flex-stack py-5 border-bottom border-gray-300 border-bottom-dashed cursor-pointer" 
                             (click)="toggleTagSelection(tag)">
                             
                          <!-- Circle with First Letter -->
                          <div class="d-flex align-items-center">
                            <div class="symbol symbol-50px me-6" [ngbTooltip]="'ID: ' + tag.id" container="body">
                              <div class="symbol-label" [ngStyle]="{'background-color': tag.color}">
                                <span class="text-white fs-2">{{ tag.value.charAt(0).toUpperCase() }}</span>
                              </div>
                            </div>
                      
                            <!-- Tag Details -->
                            <div class="d-flex flex-column">
                              <span class="fw-bold fs-6">{{ tag.value }}</span>
                              <span class="fs-7 text-muted">{{ 'CAMPAIGN.TAG_NAME' | translate }}</span>
                            </div>
                          </div>
                      
                          <!-- Selection Checkbox -->
                          <span class="form-check form-check-custom form-check-solid">
                            <input class="form-check-input" type="checkbox" [checked]="isTagSelected(tag)" />
                          </span>
                        </div>
                      </div>
                      
                </div>

                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" (click)="closeModal()">
                        {{ 'CAMPAIGN.CANCEL' | translate }}
                    </button>
                    <button type="button" class="btn btn-primary" [disabled]="!selectedTags.length" (click)="selectTags()">
                        {{ 'CAMPAIGN.ADD_TAGS' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
